import api from './api'
import { NotaFiscalOperacao, NotaFiscalOperacaoRequest } from '@/types/notaFiscalOperacao'

const BASE = (oportunidadeId: string) => `/api/v1/oportunidades/${oportunidadeId}/notas-fiscais`

export const notaFiscalOperacaoService = {
  listar: async (oportunidadeId: string): Promise<NotaFiscalOperacao[]> =>
    api.get<NotaFiscalOperacao[]>(BASE(oportunidadeId)),

  adicionar: async (
    oportunidadeId: string,
    request: NotaFiscalOperacaoRequest
  ): Promise<NotaFiscalOperacao> =>
    api.post<NotaFiscalOperacao>(BASE(oportunidadeId), request),

  atualizar: async (
    oportunidadeId: string,
    nfId: string,
    request: NotaFiscalOperacaoRequest
  ): Promise<NotaFiscalOperacao> =>
    api.put<NotaFiscalOperacao>(`${BASE(oportunidadeId)}/${nfId}`, request),

  deletar: async (oportunidadeId: string, nfId: string): Promise<void> => {
    await api.delete(`${BASE(oportunidadeId)}/${nfId}`)
  },
}
